module.exports = __webpack_public_path__ + "static/media/offlinePOS.6b8a7b6e.svg";